import useSideScrollbar from '../hooks/useSideScrollbar';
import '../css/VerticalScrollArea.css';

/**
 * A vertically-scrolling area with a thin drawn scrollbar on its right, in
 * the active button colour, that shows on every device (phones included) and
 * only while the content overflows. The height limit comes from the caller's
 * CSS (e.g. a max-height on `className`).
 *
 * @param {object} props
 * @param {string} [props.className] - extra classes for the scrolling element
 * @param {string} [props.wrapClassName] - extra classes for the outer wrapper
 * @param {React.ReactNode} props.children - the scrolling content
 * @returns {JSX.Element}
 */
function VerticalScrollArea({ className = '', wrapClassName = '', children }) {
  const { wrapRef, scrollerRef, contentRef, trackRef, thumbRef } = useSideScrollbar();

  return (
    <div className={`vsa ${wrapClassName}`.trim()} ref={wrapRef}>
      <div className={`vsa-scroller ${className}`.trim()} ref={scrollerRef}>
        <div className="vsa-content" ref={contentRef}>{children}</div>
      </div>
      <div className="vsa-track" ref={trackRef} aria-hidden="true">
        <div className="vsa-thumb" ref={thumbRef} />
      </div>
    </div>
  );
}

export default VerticalScrollArea;
